const columns = [

    {
        label: "Nazwa",
        field: "name",
        width: 53
    },
]

export default columns;